import { BeFigure, FigureData, preProcessFigureInput, TypeAheadItem } from "aic";
import { AppSettingsContext } from "contexts/AppSettingsContext";
import { HierarchyContext } from "contexts/HierarchyContext";
import { UPDATE_TLF } from "contexts/tlf/interface";
import { TlfContext } from "contexts/TlfContext";
import { eTlfItemType } from "functions/api/enums";
import { getFigure } from "functions/api/figure/getFigure";
import { isTlfItemReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import React, { useContext } from "react";

/**
 * Wrapper for BeFigure that connects it to the TLF context
 */
export const InteractiveFigure: React.FC = () => {
  const appSettings = useContext(AppSettingsContext);
  const hierarchyContext = useContext(HierarchyContext);
  const tlfContext = useContext(TlfContext);
  const body = isTlfItemReadDto(tlfContext?.tlfData) ? tlfContext.tlfData.body : undefined;

  const clinicalLibrary = hierarchyContext?.hierarchy?.clinicalLibrary;
  const varNames: TypeAheadItem[] = clinicalLibrary?.clinicalDatasets.flatMap((ds) => {
    const vars = ds.clinicalVariables.map((v) => v.name);
    return vars.map((v) => ({ value: `${ds.name}.${v}` }));
  }) ?? [{ value: "No variables available" }];

  const figureInput: FigureData | undefined =
    tlfContext?.tlfData?.type === eTlfItemType.figure
      ? preProcessFigureInput(appSettings.figureSettings, body as FigureData)
      : undefined;

  return !figureInput || !tlfContext ? null : (
    <BeFigure
      backEndUrl={appSettings.backEndUrl}
      externalFigureRequest={getFigure}
      figureSettings={appSettings.figureSettings}
      figureInput={figureInput}
      varNames={varNames}
      updateFigureInput={(newBody: FigureData) => {
        tlfContext.dispatch({
          operation: UPDATE_TLF,
          tlfData: {
            body: newBody,
          },
          calledFrom: "BeFigureOptions:updateFigureInput",
        });
      }}
    />
  );
};

InteractiveFigure.displayName = "InteractiveFigure";
